import { SteemActionType } from '@popup/steem/actions/action-type.enum';
export const setProcessingDecryptAccount = (processingDecryptAccount) => {
    return {
        type: SteemActionType.SET_APP_STATUS,
        payload: {
            processingDecryptAccount: processingDecryptAccount,
        },
    };
};
